import { useAuth } from "../contexts/AuthContext";
import AccessDenied from "../pages/AccessDenied";
import UpgradePlan from "../pages/UpgradePlan";
import LoadingScreen from "./LoadingScreen/LoadingScreen";

const ProtectedRoute = ({
  children,
  roles = [],
  module,
  feature,
  requireAll = false,
  fallback = "access-denied",
  customFallback,
  featureName,
  description,
  customCheck, // NEW: Support custom authorization logic
}) => {
  const auth = useAuth();
  const { isAuthorized, canAccessModule, isLoading } = auth;

  if (isLoading) {
    return <LoadingScreen />;
  }

  let hasAccess = false;

  // 1) If customCheck is provided, use it (highest priority)
  if (typeof customCheck === "function") {
    hasAccess = customCheck(auth);
  } else {
    // 2) Otherwise, use the existing role/feature/module logic
    const baseAuthorized = isAuthorized({
      roles,
      module,
      feature,
      requireAll,
    });

    // 3) Extra module gate using canAccessModule
    const hasModuleAccess =
      module && typeof canAccessModule === "function"
        ? canAccessModule(module)
        : true;

    hasAccess = baseAuthorized && hasModuleAccess;
  }

  // If no access, render appropriate fallback
  if (!hasAccess) {
    if (customFallback) {
      return customFallback;
    }
    if (fallback === "upgrade-plan") {
      return (
        <UpgradePlan featureName={featureName} description={description} />
      );
    }
    return <AccessDenied />;
  }

  return children;
};

export default ProtectedRoute;
